import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
} from '../../models/Theme.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance_0,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from './ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../helpers.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from './ActivityIndicator.commonHtml.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  listOfNotNull1v4ggfackvuny as listOfNotNull,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance } from '../../models/data.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../../afterTimeout.mjs';
import { get_areAnimationsEnabled2k2xqxuhspcz8 as get_areAnimationsEnabled } from '../RView.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { RawImageView3rlp4gsc2bxt0 as RawImageView } from './RawImageView.commonHtml.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var InfoClass;
function Info() {
  if (InfoClass === VOID) {
    class $ {
      constructor(sources, scaleType, description) {
        this.vd9_1 = sources;
        this.wd9_1 = scaleType;
        this.xd9_1 = description;
      }
      yd9(sources, scaleType, description) {
        return new (Info())(sources, scaleType, description);
      }
      zd9(sources, scaleType, description, $super) {
        sources = sources === VOID ? this.vd9_1 : sources;
        scaleType = scaleType === VOID ? this.wd9_1 : scaleType;
        description = description === VOID ? this.xd9_1 : description;
        return $super === VOID ? this.yd9(sources, scaleType, description) : $super.yd9.call(this, sources, scaleType, description);
      }
      toString() {
        return 'Info(sources=' + toString(this.vd9_1) + ', scaleType=' + this.wd9_1.toString() + ', description=' + this.xd9_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.vd9_1);
        result = imul(result, 31) + this.wd9_1.hashCode() | 0;
        result = imul(result, 31) + (this.xd9_1 == null ? 0 : getStringHashCode(this.xd9_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Info()))
          return false;
        if (!equals(this.vd9_1, other.vd9_1))
          return false;
        if (!this.wd9_1.equals(other.wd9_1))
          return false;
        if (!(this.xd9_1 == other.xd9_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Info');
    InfoClass = $;
  }
  return InfoClass;
}
function Frame$_get_shown_$ref_dnks5k(p0) {
  return () => p0.wb8();
}
function Frame$_set_shown_$ref_s2otf0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function ImageView$refresh$lambda(this$0, $it) {
  return () => {
    this$0.ada_1.sba($it);
    return Unit_instance;
  };
}
var ImageView$refresh$$inlined$let$1Class;
function ImageView$refresh$$inlined$let$1() {
  if (ImageView$refresh$$inlined$let$1Class === VOID) {
    class $ {
      constructor($$this$with) {
        this.mda_1 = $$this$with;
      }
      fd1(theme) {
        return this.mda_1.aba().pb6_1.fb1_1 ? theme.yb0_1 : theme.ab1_1;
      }
    }
    protoOf($).ybe = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    ImageView$refresh$$inlined$let$1Class = $;
  }
  return ImageView$refresh$$inlined$let$1Class;
}
function ImageView$refresh$lambda_0($$this$rawImage, this$0, $info) {
  return ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_0 = $this$reactive.daj($$this$rawImage.pca_1);
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
    if (!equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        var it = _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
        if (equals(this$0.fda_1, $info)) {
          this$0.hda_1.eb7(0.0);
          this$0.ida_1.pah(Companion_getInstance_0().uah(it));
          this$0.fda_1 = null;
          if (!(this$0.bda_1 === $info)) {
            this$0.nas();
          }
        }
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          var tmp = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
          if (!(tmp == null ? true : !(tmp == null)))
            THROW_CCE();
          $$this$rawImage.eb7(1.0);
          if (equals(this$0.fda_1, $info)) {
            this$0.hda_1.eb7(0.0);
            this$0.ida_1.pah(_ReactiveState___init__impl__fvdp9b($info));
          }
        } else {
          _ReactiveState___get_raw__impl__92ipya(this_0);
          $$this$rawImage.eb7(1.0);
          if (equals(this$0.fda_1, $info)) {
            this$0.hda_1.eb7(0.0);
            this$0.ida_1.pah(_ReactiveState___init__impl__fvdp9b($info));
          }
        }
      }
    }
    return Unit_instance;
  };
}
function ActivityIndicator$_get_shown_$ref_61t2d1(p0) {
  return () => p0.wb8();
}
function ActivityIndicator$_set_shown_$ref_zcnirl(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ImageViewClass;
function ImageView() {
  if (ImageViewClass === VOID) {
    class $ {
      constructor(viewWriter) {
        var tmp = this;
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(viewWriter.pc());
        var tmp0_elvis_lhs = viewWriter.cbb_1;
        var p = tmp0_elvis_lhs == null ? viewWriter : tmp0_elvis_lhs;
        viewWriter.ebb(p, view);
        viewWriter.fbb(p, view);
        tmp.ada_1 = view;
        this.bda_1 = null;
        this.cda_1 = false;
        this.dda_1 = false;
        this.eda_1 = false;
        this.fda_1 = null;
        this.gda_1 = null;
        // Inline function 'kotlin.with' call
        var $this$with = this.ada_1;
        var tmp_0 = get_centered($this$with);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (ActivityIndicator())($this$with.pc());
        var tmp0_elvis_lhs_0 = $this$with.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? $this$with : tmp0_elvis_lhs_0;
        $this$with.ebb(p_0, view_0);
        this.kda_1 = false;
        this.hda_1 = view_0;
        view_0.eb7(0.0);
        $this$with.fbb(p_0, view_0);
        $this$with.jbb(tmp_0, view_0);
        this.ida_1 = RawReactive().yah(_ReactiveState___init__impl__fvdp9b(null));
        var tmp_1 = this;
        var tmp0 = this.ada_1;
        var tmp_2 = KMutableProperty0();
        var tmp_3 = Frame$_get_shown_$ref_dnks5k(tmp0);
        tmp_1.jda_1 = getPropertyCallableRef('shown', 0, tmp_2, tmp_3, Frame$_set_shown_$ref_s2otf0(tmp0));
        this.kda_1 = false;
        var tmp_4 = this;
        var tmp0_0 = this.hda_1;
        var tmp_5 = KMutableProperty0();
        var tmp_6 = ActivityIndicator$_get_shown_$ref_61t2d1(tmp0_0);
        tmp_4.lda_1 = getPropertyCallableRef('shown', 0, tmp_5, tmp_6, ActivityIndicator$_set_shown_$ref_zcnirl(tmp0_0));
      }
      aba() {
        return this.ada_1;
      }
      ea2() {
        return this.ada_1.ea2();
      }
      nda(value) {
        this.bda_1 = value;
        if (this.eda_1) {
          this.nas();
        }
      }
      oda(value) {
        var tmp0_safe_receiver = this.bda_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zd9(listOfNotNull(value));
        this.nda(tmp1_elvis_lhs == null ? new (Info())(listOfNotNull(value), ImageScaleType_Fit_getInstance(), null) : tmp1_elvis_lhs);
      }
      i2i() {
        var tmp0_safe_receiver = this.bda_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vd9_1;
        return tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
      }
      pda(value) {
        var tmp0_safe_receiver = this.bda_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zd9(VOID, value);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = new (Info())(tmp$ret$0, value, null);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        this.nda(tmp);
      }
      ebu(value) {
        var tmp0_safe_receiver = this.bda_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zd9(VOID, VOID, value);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = new (Info())(tmp$ret$0, ImageScaleType_Fit_getInstance(), value);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        this.nda(tmp);
      }
      zba() {
        this.eda_1 = true;
        this.nas();
      }
      nas() {
        if (!this.eda_1)
          return Unit_instance;
        var info = this.bda_1;
        if (!equals(this.fda_1, info)) {
          var tmp0_safe_receiver = this.gda_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (get_areAnimationsEnabled(this.ada_1)) {
                element.eb7(0.0);
                var tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(element.kba().tb0_1);
                afterTimeout(this, tmp, ImageView$refresh$lambda(this, element));
              } else {
                this.ada_1.sba(element);
              }
            }
          }
          this.ida_1.pah(Companion_getInstance_0().mah_1);
          this.fda_1 = info;
          this.hda_1.eb7(1.0);
          var tmp_0 = this;
          var tmp_1;
          if (info == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.buildList' call
            // Inline function 'kotlin.collections.buildListInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = ArrayList().w();
            // Inline function 'kotlin.with' call
            var $this$with = this.ada_1;
            var _iterator__ex2g4s_0 = info.vd9_1.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var imageSource = _iterator__ex2g4s_0.o1();
              // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
              Companion_getInstance();
              var tmp$ret$2 = new (ImageView$refresh$$inlined$let$1())($this$with);
              $this$with.hbb(tmp$ret$2);
              var tmp0_elvis_lhs = info.xd9_1;
              var tmp4 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
              // Inline function 'com.lightningkite.kiteui.views.direct.rawImage' call
              var scaleType = info.wd9_1;
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RawImageView())($this$with.pc(), imageSource, tmp4, scaleType);
              var tmp0_elvis_lhs_0 = $this$with.cbb_1;
              var p = tmp0_elvis_lhs_0 == null ? $this$with : tmp0_elvis_lhs_0;
              $this$with.ebb(p, view);
              view.iba(true);
              view.eb7(0.0);
              reactive(view, ImageView$refresh$lambda_0(view, this, info));
              $this$with.fbb(p, view);
              this_0.v(view);
            }
            tmp_1 = this_0.c8();
          }
          var tmp2_elvis_lhs = tmp_1;
          var tmp_2;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            this.ida_1.pah(_ReactiveState___init__impl__fvdp9b(null));
            this.hda_1.eb7(0.0);
            tmp_2 = null;
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }
          tmp_0.gda_1 = tmp_2;
        }
      }
    }
    initMetadataForClass($, 'ImageView', VOID, VOID, [CoroutineScope()]);
    ImageViewClass = $;
  }
  return ImageViewClass;
}
//region block: exports
export {
  ImageView as ImageViewadm9fg4ms58f,
};
//endregion

//# sourceMappingURL=ImageView.mjs.map
